import React, { useContext, useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import Search from "../../components/Search/Search";
import Card from "../../components/Cards/Card";
import ServiceType from "./JobCardStats/ServiceType";
import LobWise from "./JobCardStats/LobWise";
import Workshop from "./JobCardStats/Workshop";
import RegionWise from "./JobCardStats/RegionWise";
import Chassis from "./JobCardStats/Chassis";
import { FilterContext } from "../../context/Filter";
import NavButtons from "../../components/NevBar/NavButtons";

function Index() {
  const [isArn, setIsArn] = useState(null);
  const [isSearchArn, setIsSearchArn] = useState(false);
  const { arn: parArn, childArn } = useContext(FilterContext);
  const arn = parArn || childArn;

  const handleGlobalSearch = () => {
    if (arn) {
      setIsSearchArn(true);
    }
  };

  useEffect(() => {
    if (arn) {
      setIsArn(arn);
      setIsSearchArn(arn);
    }
  }, [arn]);

  return (
    <div>
      <Header heading={"Live Job Cards"} />

      <div className="bg-gray-100 min-h-screen">
        {/* Dashboard Container */}
        <div className="mx-auto px-4 py-1">
          {/* Dashboard Header */}

          {/* Filter Section */}
          {/* <Search
          isArn={isArn}
          setIsArn={setIsArn}
          handleSearchFromParent={handleGlobalSearch}
        /> */}

          {/* Card */}
          <Card
            isArn={isArn}
            isSearchArn={isSearchArn}
            setIsSearchArn={setIsSearchArn}
            setIsArn={setIsArn}
            isWaterMark={null} // no watermark now
          />

          {/* Dashboard Panels */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
            <div className="p-2 rounded-lg shadow-xl w-full">
              <h2 className="text-lg font-semibold text-black mb-2">
                Open Job Cards by LOB
              </h2>
              <div className="w-full bg-white rounded-lg h-[220px]">
                <LobWise
                  isArn={isArn}
                  isSearchArn={isSearchArn}
                  setIsSearchArn={setIsSearchArn}
                  setIsArn={setIsArn}
                  isWaterMark={null}
                />
              </div>
            </div>

            <div className="p-2 rounded-lg shadow-xl w-full">
              <h2 className="text-lg font-semibold text-black mb-2">
                Open Job Cards by Service Type
              </h2>
              <div className="w-full bg-white rounded-lg h-[220px]">
                <ServiceType
                  isArn={isArn}
                  isSearchArn={isSearchArn}
                  setIsSearchArn={setIsSearchArn}
                  setIsArn={setIsArn}
                  isWaterMark={null}
                />
              </div>
            </div>

            <div className="p-2 rounded-lg shadow-xl w-full">
              <h2 className="text-lg font-semibold text-black mb-2">
                Top 5 Workshops with Open Job Cards
              </h2>
              <div className="w-full p-2 bg-white rounded-lg h-[220px]">
                <Workshop
                  isArn={isArn}
                  isSearchArn={isSearchArn}
                  setIsSearchArn={setIsSearchArn}
                  setIsArn={setIsArn}
                  isWaterMark={null}
                />
              </div>
            </div>

            <div className="p-2 rounded-lg shadow-xl w-full">
              <h2 className="text-lg font-semibold text-black mb-2">
                Open Job Cards by Region
              </h2>
              <div className="w-full p-2 bg-white rounded-lg h-[200px]">
                <RegionWise
                  isArn={isArn}
                  isSearchArn={isSearchArn}
                  setIsSearchArn={setIsSearchArn}
                  setIsArn={setIsArn}
                  isWaterMark={null}
                />
              </div>
            </div>

            <div className="p-2 rounded-lg shadow-xl col-span-1 md:col-span-2">
              <h2 className="text-xl font-semibold text-black mb-2">
                Chassis Wise Details of Job Cards
              </h2>
              <Chassis
                isArn={isArn}
                isSearchArn={isSearchArn}
                setIsSearchArn={setIsSearchArn}
                setIsArn={setIsArn}
                isWaterMark={null}
              />
            </div>
          </div>
        </div>    </div>
      <NavButtons />

    </div>
  );
}

export default Index;
